import React, { useState, useContext } from "react";
import { api } from "../utils/apiHelper";
import UserContext from "../context/UserContext";
import "../styles/specialProd.css";

const SpecialProd = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [priceOptions, setPriceOptions] = useState("0,15,25,35");
  const [file, setFile] = useState(null);
  const [image, setImage] = useState(null);
  const [uploading, setUploading] = useState(false);

  const { authUser } = useContext(UserContext);

  if (!authUser || authUser.email !== "support@editfarmer.com") {
    return null;
  }

  const uploadToS3 = async (selectedFile, uploadType, productId) => {
    const signRes = await api("/special-product-s3-url", "POST", {
      fileName: selectedFile.name,
      fileType: selectedFile.type,
      userId: authUser._id,
      productId,
      uploadType,
    });

    const upload = await fetch(signRes.signedUrl, {
      method: "PUT",
      headers: { "Content-Type": selectedFile.type },
      body: selectedFile,
    });

    if (!upload.ok) {
      throw new Error(`S3 upload failed (${upload.status})`);
    }

    return {
      key: signRes.key,
      url: signRes.url,
    };
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setUploading(true);

    try {
      const productId = crypto.randomUUID();

      const uploadedImage = image
        ? await uploadToS3(image, "image", productId)
        : null;

      const uploadedFile = file
        ? await uploadToS3(file, "file", productId)
        : null;

      const payload = {
        ownerEmail: "support@editfarmer.com",
        productId,
        title,
        description,
        image: uploadedImage,
        file: uploadedFile ? { ...uploadedFile, fileName: file.name } : null,
        priceOptions: priceOptions.split(",").map((n) => Number(n.trim())),
        productType: "special",
        active: true,
      };

      const response = await api("/special-product/create", "POST", payload);

      if (!response?.success) {
        alert("Failed to create special product.");
        return;
      }

      setTitle("");
      setDescription("");
      setPriceOptions("0,15,25,35");
      setImage(null);
      setFile(null);

      alert("Special product created.");
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="special-prod-wrapper">
      <h2>Create Special Product</h2>

      <form onSubmit={handleSubmit} className="special-prod-form">
        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Product title" required />

        <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Product description" required />

        <input type="text" value={priceOptions} onChange={(e) => setPriceOptions(e.target.value)} placeholder="0,15,25,35" />

        <div className="drop-zone" onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); setImage(e.dataTransfer.files[0]); }} onClick={() => document.getElementById("imageUpload").click()}>
          {image ? image.name : "Drag & Drop Product Image or Click"}
        </div>

        <input id="imageUpload" type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => setImage(e.target.files[0])} />

        <div className="drop-zone" onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); setFile(e.dataTransfer.files[0]); }} onClick={() => document.getElementById("productUpload").click()}>
          {file ? file.name : "Drag & Drop Product File or Click"}
        </div>

        <input id="productUpload" type="file" style={{ display: "none" }} onChange={(e) => setFile(e.target.files[0])} />

        <button type="submit" disabled={uploading}>
          {uploading ? "Uploading..." : "Create Special Product"}
        </button>
      </form>
    </div>
  );
};

export default SpecialProd;